<template>
  <ItemDialog ref="purchaseVersionWarning" image-type="alert">
    <template #content-area>
      <div class="text-caution">
        <h1>
          <strong>アプリバージョンエラー</strong>
        </h1>
      </div>
      <div class="text-center">
        <p>
          アプリを最新バージョンにアップデートして、もう一度お試しください。
        </p>
      </div>
    </template>
    <template #button-area>
      <ItemButton
        label="OK"
        action-type="btn-primary"
        @clicked="closeDialog()"
      />
    </template>
  </ItemDialog>
</template>

<script>
import { ref } from "vue";

export default {
  name: "DialogPurchaseVersionWarning",

  setup() {
    const purchaseVersionWarning = ref(null);

    const openDialog = () => {
      purchaseVersionWarning.value.open();
    };

    const closeDialog = () => {
      purchaseVersionWarning.value.close();
    };

    return {
      purchaseVersionWarning,
      openDialog,
      closeDialog,
    };
  },
};
</script>

<style scoped lang="scss">
.text-center {
  text-align: justify;
  font-size: 3vw;
}

.text-caution {
  text-align: center;
  margin-bottom: 1.5rem;
  font-weight: bold;
  font-size: 4vw !important;
}
</style>
